"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importStar(require("react"));
var buttons_1 = require("../buttons");
var Modal_scss_1 = __importDefault(require("./Modal.scss"));
var classnames_1 = __importDefault(require("classnames"));
var Modal = function (_a) {
    var id = _a.id, title = _a.title, open = _a.open, onClose = _a.onClose, children = _a.children, props = __rest(_a, ["id", "title", "open", "onClose", "children"]);
    (0, react_1.useEffect)(function () {
        if (!open) {
            return;
        }
        var body = document.getElementsByTagName('body')[0];
        var bodyClass = body.className;
        body.className = (0, classnames_1.default)(bodyClass, 'modal-open');
        var backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        body.appendChild(backdrop);
        setTimeout(function () {
            props.onOpened && props.onOpened();
        }, 1);
        return function () {
            body.setAttribute('class', bodyClass);
            body.removeChild(backdrop);
        };
    }, [open]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('modal fade', { show: open }), tabIndex: -1, role: "dialog", style: open ? { paddingRight: '15px', display: 'block' } : { display: 'none' } },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-dialog', props.size && "modal-".concat(props.size), props.className), role: "document", id: id },
            react_1.default.createElement("div", { className: "modal-content" },
                react_1.default.createElement("div", { className: "modal-header" },
                    react_1.default.createElement("h5", { className: "modal-title" }, title),
                    react_1.default.createElement("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", onClick: onClose },
                        react_1.default.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
                react_1.default.createElement("div", { className: "modal-body" }, children),
                props.leftButtons || props.rightButtons ? (react_1.default.createElement("div", { className: "modal-footer" },
                    props.leftButtons &&
                        props.leftButtons.map(function (r, i) {
                            return i == props.leftButtons.length - 1 ? (react_1.default.createElement(buttons_1.Button, __assign({ key: i }, r, { className: (0, classnames_1.default)(Modal_scss_1.default['au-modal-button-push'], r.className) }))) : (react_1.default.createElement(buttons_1.Button, __assign({ key: i }, r)));
                        }),
                    props.rightButtons && props.rightButtons.map(function (r, i) { return react_1.default.createElement(buttons_1.Button, __assign({ key: i }, r)); }))) : (react_1.default.createElement(react_1.default.Fragment, null))))));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map